import { render, staticRenderFns } from "./AdminInvoicesHosts.vue?vue&type=template&id=0fabc302&scoped=true&"
import script from "./AdminInvoicesHosts.vue?vue&type=script&lang=js&"
export * from "./AdminInvoicesHosts.vue?vue&type=script&lang=js&"
import style0 from "./AdminInvoicesHosts.vue?vue&type=style&index=0&id=0fabc302&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fabc302",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCard,VIcon,VTab,VTabItem,VTabs,VTabsItems})
